<template>
  <div v-loading="loadingPrincipal" class="sectionContainer">
    <div v-if="!loadingPrincipal">
      <Title title="Seguimiento"
             subtitle="Sigue el progreso de las rutas activas y finalizadas"/>
      <div class="content">
        <div class="top">
          <el-row class="search-box greenAppend">
            <el-col :span="6">
              <TracingSearch
                ref="searchBox"
                :valueInput="variable"
                :toSearch="clickOnClientValue"
                @data="infoData"
                @clickSearchLupa="cleanData"
                @loaderSearch="updateLoader"
                @notFound="setNotFound"
                @type="infoType"
                @active="showHide"
                @restart="homeView" />
            </el-col>
          </el-row>
        </div>
        <div v-if="searchActive === 0">
          <div v-if="!show404">
            <el-row class="paddingTop paddingContainer" v-loading="loading">
              <el-col :span="5">
                <div v-if="loadingTree">
                  <p style="font-size: 14px; color: #A0BE03">
                    <i class="el-icon-loading" style="margin-right: 5px;"></i>CARGANDO RUTAS
                  </p>
                </div>
                <el-input
                  placeholder="Ingresa patente o ruta"
                  prefix-icon="el-icon-search"
                  size="mini"
                  v-model="filterTextThree">
                </el-input>
                <div class="tree" v-show="!loadingTree">
                  <div class="checkAll">
                      <el-checkbox
                        style="font-size: 18px; margin-top: 10px;"
                        disabled
                        @change="selectedAll">TODAS
                      </el-checkbox>
                  </div>
                  <!-- @check="handleClickTree" -->
                  <el-tree
                    style="margin-right: 20px; font-size: small;"
                    ref="entrerpriceTree"
                    :data="dataTree"
                    empty-text="SIN DATA"
                    :filter-node-method="filterNode"
                    :render-after-expand="render"
                    node-key="id"
                    show-checkbox
                    @check-change="handleCheckChange"
                    :props="defaultProps">
                  </el-tree>
                </div>
              </el-col>
              <el-col :span="19">
                <tracing-routes-table-v2
                  @loadTree = "finishLoadTable"
                  ref="tableRoutesActives"
                  @clickSoc="socDetails"
                  :routes="selectedRoutesSocActives" >
                </tracing-routes-table-v2>
              </el-col>
            </el-row>
          </div>
          <div v-else class="emptyStyle">
            <NotFound
              imgName="fb-map.svg"
              textGreen="No se encontraron"
              textGrey="rutas para hoy" />
          </div>
        </div>
        <div v-else>
          <TracingClient
            class="paddingContainer paddingTop"
            v-loading="loadingState"
            v-if="typeSearch === 2"
            @restart="homeView"
            @clickOnClient="sendClientData"
            :dataClient="dataSearchClient"
            :routes="routes"
            :notFound="displayNotFound"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment-timezone';
import { tenantTimeZone } from '@/mixins/tenants';
import { apiRequest } from '../../backend/vue-axios/axios';
// import utils from '../../mixins/utils';
import Title from '../components/base/Title.vue';
import TracingSearch from '../components/TracingSearch.vue';
import NotFound from '../components/Base404.vue';
import TracingClient from '../components/TracingClient.vue';
import TracingRoutesTableV2 from '../components/TracingRoutesTableV2.vue';

export default {
  props: {
    windowWidth: {
      type: Number,
    },
  },
  name: 'TracingV1',
  components: {
    TracingRoutesTableV2,
    TracingClient,
    TracingSearch,
    Title,
    NotFound,
  },
  data() {
    return {
      filterTextThree: '',
      loadingTree: false,
      loadingPrincipal: false,
      loading: false,
      loadComponents: false,
      show404: false,
      displayNotFound: false,
      searchActive: 0,
      variable: 0,
      typeSearch: 0,
      dataSearchDriver: {},
      dataSearchClient: {},
      dataDriverforClient: {},
      input: {},
      routes: [],
      typeResult: 0,
      chartDataInfo: [],
      loadingState: true,
      searchedInfo: {},
      clickOnClientValue: '',
      selectedId: '',
      selectedEnterprise: 'General',
      selectedResult: [],
      dataTree: [],
      defaultProps: {
        children: 'active_routes',
        label: 'name',
      },
      dataEnterprisesActiveRoutes: [],
      dataRoutesActive: [],
      selectedRoutesActives: [],
      selectedRoutesSocActives: [],
      showTable: true,
      render: false,
      filterText: '',
      allRouteData: [],
      allEnterpriceData: [],
      timeZone: '',
    };
  },
  methods: {
    filterNode(value, data) {
      if (!value) return true;
      return data.name.indexOf(value) !== -1;
    },
    setNotFound(data) {
      this.displayNotFound = data;
    },
    finishLoadTable() {
      // this.loadingTree = false;
    },
    showHide(active) {
      this.searchActive = active;
    },
    sendClientData(data) {
      this.clickOnClientValue = data.toString();
    },
    getRouteClientView(vehicle) {
      apiRequest(vehicle).then((res) => {
        this.dataDriverforClient = res.data;
        this.routes = [this.dataDriverforClient];
      }).catch(() => {
        this.$notify.error({
          title: 'Error',
          message: 'Error al cargar información',
        });
      });
    },
    infoData(data) {
      this.searchedInfo = data;
      if (this.typeSearch === 2) {
        this.dataSearchClient = this.searchedInfo;
        this.$router.push({ name: 'TracingV1', query: { v: data.suborder.code } });
      }
      this.loadingState = false;
    },
    updateLoader(data) {
      this.loadingState = data;
    },
    infoType(type) {
      this.typeSearch = type;
    },
    homeView(restart) {
      this.searchActive = restart;
      this.variable = this.variable + 1;
    },
    // tree
    getRoutesActive() {
      if (sessionStorage.active_routes !== undefined) {
        this.dataRoutesActive = JSON.parse(sessionStorage.active_routes);
      } else {
        apiRequest({
          module: 'tracing',
          service: 'get_active_routes',
        }).then((data) => {
          this.dataRoutesActive = data.data;
          sessionStorage.active_sroutes = JSON.stringify(this.dataRoutesActive);
        }).catch(() => {
          this.$notify.error({
            title: 'Error',
            message: 'Error al obtener rutas del día. Tree',
          });
        });
      }
    }, // DATOS QUE COMPLETAN TREE
    enterprisesActiveRoutes(typeUpdate) {
      this.loadingPrincipal = true;
      if (sessionStorage.dataEnterprisesActiveRoutes !== undefined) {
        this.dataEnterprisesActiveRoutes = JSON.parse(sessionStorage.dataEnterprisesActiveRoutes);
        if (typeUpdate === 'update') {
          this.updateDataRoutes();
        } else {
          this.formatDataRoutes();
        }
        this.loadingPrincipal = false;
      } else {
        apiRequest({
          module: 'tracing',
          service: 'enterprises_active_routes',
        }).then((data) => {
          this.dataEnterprisesActiveRoutes = data.data;
          // eslint-disable-next-line
          sessionStorage.dataEnterprisesActiveRoutes = JSON.stringify(data.data);
          if (typeUpdate === 'update') {
            this.updateDataRoutes();
          } else {
            this.formatDataRoutes();
          }
          this.loadingPrincipal = false;
        }).catch((err) => {
          if (err.response.status === 404) {
            this.show404 = true;
          } else {
            this.$notify.error({
              title: 'Error',
              message: 'Error al obtener información de rutas del día',
            });
          }
          this.loadingPrincipal = false;
        });
      }
    },
    updateDataRoutes() {
      const newDataTree = [];
      this.dataEnterprisesActiveRoutes.forEach((e) => {
        const child = [];
        e.active_routes.forEach((a) => {
          const dataTreeResult = this.dataTree.find(dt => dt.id === a.id);
          let selectedChild = false;
          if (dataTreeResult) {
            selectedChild = dataTreeResult[0].selected;
          }
          const ruta = {
            empId: e.id,
            id: a.id,
            name: a.patent,
            type: 'vehicle',
            selected: selectedChild,
          };
          child.push(ruta);
        });
        const dataTreeResultEmp = this.dataTree.find(dt => dt.id === e.id);
        let selectedEmp = false;
        if (dataTreeResultEmp) {
          selectedEmp = dataTreeResultEmp[0].selected;
        }
        const reparto = {
          id: e.id,
          name: e.name,
          type: 'enterprise',
          selected: selectedEmp,
          active_routes: child,
        };
        newDataTree.push(reparto);
      });
      this.dataTree = newDataTree;
    },
    formatDataRoutes() {
      this.dataTree = [];
      if (this.dataEnterprisesActiveRoutes) {
        this.dataEnterprisesActiveRoutes.forEach((e) => {
          const child = [];
          e.active_routes.forEach((a) => {
            const ruta = {
              empId: e.id,
              id: a.id,
              name: `${a.patent} | ${a.id}`,
              type: 'vehicle',
              selected: false,
            };
            child.push(ruta);
          });
          const reparto = {
            id: e.id,
            name: e.name.replace('TRANSPORTE' || 'TRANSPORTES', 'T.'),
            type: 'enterprise',
            selected: false,
            active_routes: child,
            isWorking: false,
            itemCount: 0,
            disabled: false,
          };
          this.dataTree.push(reparto);
        });
      }
    },
    handleCheckChange(dataIn, checked) {
      // eslint-disable-next-line
      dataIn.selected = checked;
      if (dataIn && dataIn.type === 'vehicle') {
        const node = this.$refs.entrerpriceTree.getNode(dataIn.empId);
        if (!node.data.isWorking) {
          const routeId = parseInt(dataIn.id, 10);
          if (dataIn.selected) {
            this.getRouteId(routeId).then(() => {
            }).finally(() => {
              node.data.isWorking = false;
            });
          } else {
            this.selectedRoutesActives = this.selectedRoutesActives.filter(r => r.id !== routeId);
            this.removeSocTable(routeId);
          }
        } else {
          node.data.itemCount -= 1;
          if (node.data.itemCount < 1 && dataIn.selected === false) {
            node.data.isWorking = false;
          }
        }
      } else if (dataIn && dataIn.type === 'enterprise') {
        // const routeId = parseInt(dataIn.id, 10);
        const node = this.$refs.entrerpriceTree.getNode(dataIn.id);
        if (dataIn.selected) {
          node.data.isWorking = true;
          const routesId = dataIn.active_routes.map(r => r.id);
          this.getRoutes(dataIn.id, routesId).finally(() => {
            node.data.isWorking = false;
          });
          /*
          codigo viejo
          this.getRouteEnterprise(dataIn.id).finally(() => {
            node.data.isWorking = false;
          });
          */
        } else {
          // eslint-disable-next-line
          const countRoutesSelected = this.$refs.entrerpriceTree.getCheckedNodes().filter(cn => cn.empId === dataIn.id).length;
          if (countRoutesSelected === 0) {
            node.data.isWorking = true;
            // eslint-disable-next-line
            const countRoutes = this.selectedRoutesActives.filter(r => r.enterprisesid === dataIn.id).length;
            node.data.itemCount = countRoutes;
            // eslint-disable-next-line
            // eslint-disable-next-line
            this.selectedRoutesActives = this.selectedRoutesActives.filter(r => r.enterprisesid !== dataIn.id);
            // eslint-disable-next-line
            this.selectedRoutesSocActives = this.selectedRoutesSocActives.filter(r => r.enterpriseId !== dataIn.id);
            // node.data.isWorking = false;
          }
        }
      }
    },
    getRouteId(elementId) { // Llamado de a 1 ruta
      return new Promise((resolve, reject) => {
        const route = this.allRouteData.find(e => e.id === elementId);
        if (!route) {
          this.$message({
            title: 'Loading...',
            message: `Cargando información de ruta id ${elementId}`,
            duration: 8000,
            showClose: true,
          });
          apiRequest({
            module: 'tracing',
            service: 'enterprises_active_one',
            pathparam: { id: elementId },
          }).then((data) => {
            // eslint-disable-next-line
            this.allRouteData.push(data.data.routes[0]);
            // this.selectedRoutesActives.push(data.data.routes[0]);
            this.addSocTable(data.data.routes[0]);
            sessionStorage.active_route_enterprises = JSON.stringify(this.allRouteData);
            this.loadingPrincipal = false;
            resolve(true);
          }).catch((err) => {
            if (err.response.status === 404) {
              this.show404 = true;
            } else {
              this.$notify.error({
                title: 'Error',
                message: 'Error al obtener información de rutas',
              });
            }
            this.loadingPrincipal = false;
            reject(err);
          });
        } else {
          this.selectedRoutesActives.push(route);
          this.addSocTable(route);
          resolve(true);
        }
      });
    },
    getRoutes(enterpriseId, routesId) { // enterpriseId = OLD -> elementId
      return new Promise((resolve, reject) => {
        const enterpriceSelected = this.allEnterpriceData.find(e => e === enterpriseId);
        if (enterpriceSelected !== undefined) {
          const route = this.allRouteData.filter(r => r.enterprisesid === enterpriseId);
          if (route) {
            route.forEach((empRoute) => {
              const tableDataRoute = this.selectedRoutesActives.find(r => r.id === empRoute.id);
              if (!tableDataRoute) {
                this.selectedRoutesActives.push(empRoute);
                this.addSocTable(empRoute);
              }
            });
          }
          resolve(true);
        } else {
          this.$message({
            title: 'Loading...',
            message: 'Cargando información del transporte',
            duration: 8000,
            showClose: true,
          });
          apiRequest({
            module: 'tracing',
            service: 'enterprises_tracking',
            params: { ids: routesId },
          }).then((response) => {
            // eslint-disable-next-line
            response.data.routes.forEach((e) => {
              const route = this.allRouteData.find(r => r.id === e.id);
              if (route !== undefined) {
                const tableDataRoute = this.selectedRoutesActives.find(r => r.id === route.id);
                if (!tableDataRoute) {
                  this.selectedRoutesActives.push(route);
                  this.addSocTable(route);
                }
              } else {
                this.allRouteData.push(e);
                this.selectedRoutesActives.push(e);
                this.addSocTable(e);
              }
            });
            sessionStorage.active_route_enterprises = JSON.stringify(this.allRouteData);
            // this.setDataTable();
            this.allEnterpriceData.push(enterpriseId);
            sessionStorage.active_enterprises = JSON.stringify(this.allEnterpriceData);
            resolve(true);
          }).catch((err) => {
            if (err.response.status === 404) {
              this.show404 = true;
            } else {
              this.$notify.error({
                title: 'Error',
                message: 'Error al obtener información de rutas',
              });
            }
            reject(err);
          });
        }
      });
    },
    selectedAll(val) {
      // this.loadingTree = true;
      if (this.dataTree !== undefined) {
        this.dataTree.forEach((e) => {
          this.$refs.entrerpriceTree.setChecked(e.id, val, 3);
        });
      }
      this.loadingTree = false;
    },
    addSocTable(route) {
      const findingRoute = this.selectedRoutesSocActives.find(r => r.routeId === route.id);
      if (!findingRoute && route) {
        route.socs.forEach((s) => {
          const dataRowSoc = {
            patent: s.patent,
            enterpriseId: route.enterprisesid,
            routeId: s.routeId,
            soc: s.soc,
            commune: s.commune,
            locality: s.locality,
            position: s.position + 1,
            // winInit: moment(s.winInit).locale('scl').format('HH:mm'),
            // winFinish: moment(s.winFinish).locale('scl').format('HH:mm'),
            winInit: moment.utc(s.winInit).format('HH:mm'),
            winFinish: moment.utc(s.winFinish).format('HH:mm'),
            // eta: (s.position === null) ? 'L.E' : moment.utc(s.eta).format('HH:mm'),
            // fff eta: (s.position === null) ? 'L.E' : moment(s.eta).locale('scl').format('HH:mm'),
            eta: (s.position === null) ? 'L.E' : moment(s.eta).tz(this.timeZone).format('HH:mm'),
            // eslint-disable-next-line
            // real:
            // eslint-disable-next-line
            // (s.real === '0001-01-01T00:00:00Z') ? '--- : ---' : moment.utc(s.real).format('HH:mm'),
            real:
            // eslint-disable-next-line
            (s.real === '0001-01-01T00:00:00Z') ? '--- : ---' : moment(s.real).tz(this.timeZone).format('HH:mm'),
            customerName: s.customerName,
            status: s.status,
            isValid: route.id === s.routeId,
          };
          this.selectedRoutesSocActives.push(dataRowSoc);
        });
      }
    },
    removeSocTable(routeId) {
      // eslint-disable-next-line
      this.selectedRoutesSocActives = this.selectedRoutesSocActives.filter(r => r.routeId !== routeId);
    },
    cleanData() {
      this.selectedRoutesActives = [];
    },
    socDetails(soc) {
      this.selectedRoutesActives = [];
      this.$refs.searchBox.input = soc;
      this.$refs.searchBox.submit();
    },
  },
  created() {
    this.$options.interval = setInterval(() => {
      sessionStorage.removeItem('active_route_enterprises');
      sessionStorage.removeItem('dataEnterprisesActiveRoutes');
      sessionStorage.removeItem('active_enterprises');
      this.selectedRoutesActives = [];
      this.allEnterpriceData = [];
      this.selectedRoutesSocActives = [];
      if (this.dataTree !== undefined) {
        this.dataTree.forEach((e) => {
          this.$refs.entrerpriceTree.setChecked(e.id, false, 3);
        });
      }
    }, 300000);
  },
  beforeDestroy() {
    clearInterval(this.$options.interval);
  },
  mounted() {
    this.timeZone = tenantTimeZone();
    if (sessionStorage.active_route_enterprises !== undefined) {
      this.allRouteData = JSON.parse(sessionStorage.active_route_enterprises);
    }
    if (sessionStorage.active_enterprises !== undefined) {
      this.allEnterpriceData = JSON.parse(sessionStorage.active_enterprises);
    }
    this.enterprisesActiveRoutes('new');
  },
  watch: {
    filterTextThree(val) {
      const valor = val.toUpperCase();
      this.$refs.entrerpriceTree.filter(valor);
    },
    selectedResult(newEl) {
      if (newEl[0].progress.total > 0) {
        this.loadEmpty = false;
      } else {
        this.loadEmpty = true;
      }
    },
    // eslint-disable-next-line no-unused-vars
    $route(to, from) {
    },
  },
};
</script>

<style lang="scss" scoped>
  .checkAll {
    text-align: left;
  }
  .home-view {
    width: 100%;
    height: 100%;
  }
  .box-card {
    height: 550px;
  }
  .content {
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    padding-bottom: 2em;
  }
  .top {
    display: flex;
    justify-content: space-evenly;
    margin-top: -20px;
  }
  .search-box {
    width: 100%;
  }
  .paddingContainer {
    margin: 0 !important;
  }
  .paddingTop {
    padding-top: 1em;
  }
  .gutterStart {
    padding-right: 10px;
  }
  .gutterEnd {
    padding-left: 10px;
  }
  .fb-map {
    width: 320px;
  }
  .sectionContainer.wrap {
    overflow: scroll !important;
  }
  .titleStyle {
    font-size: 2em;
    font-weight: 900;
    text-transform: uppercase;
    margin: 0;
  }
  .green {
    color: $fb-green;
  }
  .grey {
    color: $fb-grey-light-50;
  }
  .emptyStyle {
    margin-top: 2em;
  }
  .tracingChart {
    z-index: 90;
  }
  @media only screen and (max-width: 1010px) and (min-width: 768px) {
    .ns {
      min-width: 55%;
    }
  }
  @media only screen and (max-width: 768px) {
    .sectionContainer {
      width: 100vw;
      position: relative;
    }
    .paddingTopSm {
      padding-top: 1em;
    }
    .paddingTop {
      padding-top: 1em;
    }
    .gutterStart {
      padding-right: 0;
    }
    .gutterEnd {
      padding-left: 0;
    }
    .titleStyle {
      font-size: 1.5em;
    }
  }
  @media only screen and (max-width: 767px) {
    .top {
      flex-direction: column;
    }
  }
</style>
